import { VODCSSModules } from 'shared/utils/wix-connect';

import styles from './loading-spinner.styl';


@VODCSSModules(styles)
export default class Spinner extends React.Component {

  static propTypes = {
    className: React.PropTypes.string,
  };

  render() {
    const { className } = this.props;

    return (
      <div className={className}
           styleName="circle" />
    );
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/spinner/loading-spinner.js